import { Error, Serializer, Deserializer } from "jsonapi-serializer";

type ModelConstructor = {
  baseURL?: string;
  headers?: { [key: string]: string };
};

export class Model {
  baseURL: string;
  headers: { [key: string]: string };

  constructor(args: ModelConstructor = {}) {
    this.headers = args.headers;
    this.baseURL = args.baseURL;
  }

  /**
   * Get the response from the provided query path
   * @param path
   * @returns
   */
  async get(path: string) {
    try {
      const response = await fetch(`${this.baseURL}/${path}`, {
        headers: this.headers
      });

      const data = await response.json();
      return this.deserialize(data);
    } catch (err) {
      return new Error(err);
    }
  }

  /**
   * Post the response to the provided query path
   * @param path
   * @param body
   * @returns
   */
  async post(path: string, body: unknown) {
    try {
      const response = await fetch(`${this.baseURL}/${path}`, {
        method: "post",
        headers: this.headers,
        body: JSON.stringify(body)
      });

      const data = await response.json();
      return this.deserialize(data);
    } catch (err) {
      return new Error(err);
    }
  }

  /**
   * Serialize the response data
   * @param collectionName
   * @param attributes
   * @param data
   * @returns
   */
  serialize(collectionName: string, attributes: Array<string>, data: unknown) {
    try {
      return new Serializer(collectionName, { attributes }).serialize(data);
    } catch (err) {
      return new Error(err);
    }
  }

  /**
   * Deserialize the response data
   * @param data
   * @returns
   */
  deserialize(data: unknown) {
    try {
      return new Deserializer({
        keyForAttribute: "camelCase"
      }).deserialize(data);
    } catch (err) {
      return new Error(err);
    }
  }
}
